export enum ClientDataRequestTypeEnum {
  Address = 'CLNT_REQ_ADDR',
  ContactInfo = 'CLNT_REQ_CONTACT',
  Owner = 'CLNT_REQ_OWNER',
  Associates = 'CLNT_REQ_ASSOC',
  CompanyInfo = 'CLNT_REQ_INFO',
  Legal = 'CLNT_REQ_LEGAL',
  PersonalInfo = 'CLNT_REQ_PERS_INFO',
  Other = 'CLNT_REQ_OTHER',
  BankAccount = 'CLNT_REQ_BANK_ACC',
}

export enum AddressTypeEnum {
  Address = 'ADR_SOC',
  MailingAddress = 'ADR_MAIL',
}
